const locale = {
    placeholder: 'Izberite čas',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/sl_SI.tsx